import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const InternalLink = styled(Link)`
  color: ${p => p.theme.text.linkInternal};

  &:hover {
    color: ${p => p.theme.text.linkInternalHover};
    text-decoration: underline;
  }
`;
